import React from 'react';

import { ExperienceEdit } from '../components/ExperienceEdit/ExperienceEdit';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

export type ExperienceEditPageProps = {
  name?: string;
};

export const ExperienceEditPage = ({
  name = 'EXPERIENCE_EDIT_PAGE',
}: ExperienceEditPageProps) => {
  useDocumentTitle('Experiences');
  return (
    <div data-test={name}>
      <ExperienceEdit />
    </div>
  );
};
